import BurnPriceDisplay from 'loyalty/components/LoyaltyBurnPriceDisplay'

interface Props {
  totalPrice: number
  pointsToApply?: number
  priceInPoints?: number
  pointsHideZeroCash?: boolean
  memberPrice?: number
  size?: 'S' | 'M' | 'L'
  saleUnit?: 'total' | 'night' | 'person' | 'day' | 'dayPerPerson'
  stacked?: boolean
}

function OfferPageBurnPriceDisplay(props: Props) {
  const {
    totalPrice,
    pointsToApply,
    priceInPoints,
    pointsHideZeroCash,
    memberPrice,
    size = 'M',
    saleUnit = 'total',
    stacked,
  } = props

  if (!pointsToApply || pointsToApply <= 0 || !priceInPoints) {
    return null
  }

  return (
    <BurnPriceDisplay
      totalPrice={totalPrice}
      pointsToBurn={pointsToApply}
      priceInPoints={priceInPoints}
      size={size}
      saleUnit={saleUnit}
      memberPrice={memberPrice}
      hideZeroCash={pointsHideZeroCash}
      stacked={stacked}
    />
  )
}

export default OfferPageBurnPriceDisplay
